import { useRouter } from "next/router";
import { decodeUri } from "@gonoodle/gn-universe-utils";

export default function useIntendedPath() {
  const router = useRouter();
  const { intendedPath } = router.query;

  return decodeUri(intendedPath);
}
